import { navigate } from "gatsby"
import { checkAccess, resourceList } from "./checkResourceAccess"

export const findWhereToNavigate = resources => {
    console.log(resources, "dkfjsldfjsldfjld")
    if (checkAccess(resourceList?.dashboard, resources)) {
        console.log(resourceList?.dashboard, resources, "dkfjsldfjsldfjld")
        navigate("/")
    } else if (checkAccess(resourceList?.patients, resources)) {
        console.log(resourceList?.patients, resources, "dkfjsldfjsldfjld")
        navigate("/patients")
    } else if (checkAccess(resourceList?.appointments, resources)) {
        console.log(resourceList?.appointments, resources, "dkfjsldfjsldfjld")
        navigate("/appointment-calendar")
    } else if (checkAccess(resourceList?.callLogs, resources)) {
        console.log(resourceList?.callLogs, resources, "dkfjsldfjsldfjld")
        navigate("/callogs")
    } else if (
        checkAccess(resourceList?.reportsGlobal, resources) ||
        // checkAccess(resourceList?.reportso, resources) ||
        checkAccess(resourceList?.reportsClinic, resources) ||
        checkAccess(resourceList?.perfReportGlobal, resources) ||
        checkAccess(resourceList?.perfReportOrg, resources) ||
        checkAccess(resourceList?.perfReportClinic, resources)
    ) {
        console.log(
            resourceList?.reportsClinic,
            resourceList?.perfReportGlobal,
            resourceList?.perfReportOrg,
            resources,
            resourceList?.perfReportClinic,
            "dkfjsldfjsldfjld"
        )
        navigate("/reports")
    } else if (checkAccess(resourceList?.invoices, resources)) {
        console.log(resourceList?.invoices, resources, "dkfjsldfjsldfjld")
        navigate("/invoices")
    } else if (
        // console.log(resourceList?.dashboard, resources, "dkfjsldfjsldfjld")
        checkAccess(resourceList?.billing, resources) ||
        checkAccess(resourceList?.billingForOrg, resources) ||
        checkAccess(resourceList?.billingForClinic, resources)
    ) {
        console.log(
            resourceList?.billing,
            resourceList?.billingForOrg,
            resources,
            resourceList?.billingForClinic,
            "dkfjsldfjsldfjld"
        )
        navigate("/billing")
    } else if (resourceList?.summary) {
        console.log(resourceList?.summary, resources, "dkfjsldfjsldfjld")
        navigate("/summary")
    }
}
